import React, { memo } from "react";
import PropTypes from "prop-types";
import EmployeeHome from "../../Employee/EmployeeHome";

/**
 * Admin /home and /admin/home entry — same personal ESS dashboard as /employee/home.
 * Workforce headcount glance lived here previously; ESS Home now shows personal punch,
 * calendar, leave, and holidays (see EmployeeHome).
 */
const Home = memo(function Home() {
  return <EmployeeHome />;
});

Home.propTypes = {
  darkMode: PropTypes.bool,
  setCurrentPage: PropTypes.func,
  toggleDarkMode: PropTypes.func,
};

export default Home;
